import { render, staticRenderFns } from "./ShowPlan.vue?vue&type=template&id=28a17773&scoped=true&"
import script from "./ShowPlan.vue?vue&type=script&lang=js&"
export * from "./ShowPlan.vue?vue&type=script&lang=js&"
import style0 from "./ShowPlan.vue?vue&type=style&index=0&id=28a17773&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a17773",
  null
  
)

export default component.exports